import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Newpassword from '../views/Newpassword.vue'
import Home from '../views/Home.vue'
import Company from '../views/Company.vue'
import Promote from '../views/Promote.vue'
import Location from '../views/Location.vue'
// import House from '../views/House.vue'
// import Control from '../views/Control.vue'
// import Setting from '../views/Setting.vue'
// import UserControl from '../views/User-Control.vue'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/newpassword',
    name: 'newpassword',
    component: Newpassword
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/company',
    name: 'company',
    component: Company
  },
  {
    path: '/promote',
    name: 'promote',
    component: Promote
  },
  {
    path: '/location',
    name: 'location',
    component: Location
  },
  // {
  //   path: '/house',
  //   name: 'house',
  //   component: House
    // children: [
    //   {
    //     // UserProfile will be rendered inside User's <router-view>
    //     // when /user/:id/profile is matched
    //     path: 'profile',
    //     component: UserProfile
    //   },
    //   {
    //     // UserPosts will be rendered inside User's <router-view>
    //     // when /user/:id/posts is matched
    //     path: 'posts',
    //     component: UserPosts
    //   }
    // ]
  // },
  // {
  //   path: '/control',
  //   name: 'control',
  //   component: Control
  // },
  // {
  //   path: '/setting',
  //   name: 'setting',
  //   component: Setting
  // },
  // {
  //   path: '/user-control',
  //   name: 'user-control',
  //   component: UserControl
  // }
  {
    path: '*',
    component: Login
  }
  // {
  //   path: '/:catchAll(.*)',
  //   component: Login
  // }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
